import styled from "styled-components";
import { Title } from "./PatientConsentManagerShared.styles";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
export const ErrorIconContainer = styled.div `
    width: 88px;
    height: 88px;
    border-radius: 50%;
    background-color: rgba(223, 40, 12, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
`;
export const ErrorIcon = styled.img `
    width: 40px;
    height: 40px;
`;
export const ErrorTitle = styled(Title) `
    text-align: center;
    font-size: ${fontSizes.MOBILE_TITLE};
    line-height: 36px;
    font-weight: 500;
    color: ${colors.black_main};
`;
export const ErrorSupportingText = styled.p `
    font-size: ${fontSizes.STANDARD};
    font-weight: normal;
    line-height: normal;
    color: ${colors.black_light};
    text-align: center;
    letter-spacing: 0.15px;
    margin: 0;
`;
